import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    vehicleConsumptionReportSearchParams:{
        primaryFilter:{
            fromDate:'',
            toDate:'',
            searchReportingView:'1',
            searchReportViewName:'Summary View',
            searchVehicleIds:'',
            searchVehiclesNos:[],
            showItemValue:1,
            showItemValueName:'No',
            searchItemCategoryIds:'',
            searchItemCategoryNames:[],
            searchItemSubCategoryIds:'',
            searchItemSubCategoryNames:[],
            searchBrandIds:'',
            searchBrandNames:[],
            searchInvItemIds:'',
            searchInvItemNames:[],
        },
    },
    vehicleConsumptionReportLists:{
        isLoading:false,
        dataLoaded:false,
        data:null,
        totalRecords:0,
        pageNo:0,
        perPageRecords:2000,
        vehicleConsumptionReportError:'',
    },
    loadVehicleConsumptionReportData: false,
}

const reportVehicleConsumptionReportSlice = createSlice({
    name: "reportVehicleConsumptionSlice",
    initialState,
    reducers: {
        vehicleConsumptionReportPrimaryFiltersUpdates: (state, {payload}) => {
            if(payload?.fromDate && payload?.fromDate !== ''){
                state.vehicleConsumptionReportSearchParams.primaryFilter.fromDate = payload.fromDate;
            }else if(payload?.fromDate === ''){
                state.vehicleConsumptionReportSearchParams.primaryFilter.fromDate = '';
            }
            
            if(payload?.toDate && payload?.toDate !== ''){
                state.vehicleConsumptionReportSearchParams.primaryFilter.toDate = payload.toDate;
            }else if(payload?.toDate === ''){
                state.vehicleConsumptionReportSearchParams.primaryFilter.toDate = '';
            }
            if(payload?.searchReportingView && payload?.searchReportingView !== ''){
                state.vehicleConsumptionReportSearchParams.primaryFilter.searchReportingView = payload.searchReportingView;
            }else if(payload?.searchReportingView === ''){
                state.vehicleConsumptionReportSearchParams.primaryFilter.searchReportingView = '';
            }
            if(payload?.searchReportViewName && payload?.searchReportViewName !== ''){
                state.vehicleConsumptionReportSearchParams.primaryFilter.searchReportViewName = payload.searchReportViewName;
            }else if(payload?.searchReportingView === ''){
                state.vehicleConsumptionReportSearchParams.primaryFilter.searchReportViewName = '';
            }
            if(payload?.searchVehicleIds && payload?.searchVehicleIds !== ''){
                state.vehicleConsumptionReportSearchParams.primaryFilter.searchVehicleIds = payload.searchVehicleIds;
            }else if(payload?.searchVehicleIds === ''){
                state.vehicleConsumptionReportSearchParams.primaryFilter.searchVehicleIds = '';
            }
            if(payload?.searchVehiclesNos && payload?.searchVehiclesNos?.length > 0){
                state.vehicleConsumptionReportSearchParams.primaryFilter.searchVehiclesNos = payload.searchVehiclesNos;
            }else if(payload?.searchVehiclesNos?.length === 0){
                state.vehicleConsumptionReportSearchParams.primaryFilter.searchVehiclesNos = [];
            }
            if(payload?.showItemValue && payload?.showItemValue !== ''){
                state.vehicleConsumptionReportSearchParams.primaryFilter.showItemValue = payload.showItemValue;
            }else if(payload?.showItemValue === ''){
                state.vehicleConsumptionReportSearchParams.primaryFilter.showItemValue = 1;
            }
            if(payload?.showItemValueName && payload?.showItemValueName !== ''){
                state.vehicleConsumptionReportSearchParams.primaryFilter.showItemValueName = payload.showItemValueName;
            }else if(payload?.showItemValueName === ''){
                state.vehicleConsumptionReportSearchParams.primaryFilter.showItemValueName = '';
            }
            if(payload?.searchItemCategoryIds && payload?.searchItemCategoryIds !== ''){
                state.vehicleConsumptionReportSearchParams.primaryFilter.searchItemCategoryIds = payload.searchItemCategoryIds;
            }else if(payload?.searchItemCategoryIds === ''){
                state.vehicleConsumptionReportSearchParams.primaryFilter.searchItemCategoryIds = '';
            }
            if(payload?.searchItemCategoryNames && payload?.searchItemCategoryNames?.length > 0){
                state.vehicleConsumptionReportSearchParams.primaryFilter.searchItemCategoryNames = payload.searchItemCategoryNames;
            }else if(payload?.searchItemCategoryNames?.length === 0){
                state.vehicleConsumptionReportSearchParams.primaryFilter.searchItemCategoryNames = [];
            }
            if(payload?.searchItemSubCategoryIds && payload?.searchItemSubCategoryIds !== ''){
                state.vehicleConsumptionReportSearchParams.primaryFilter.searchItemSubCategoryIds = payload.searchItemSubCategoryIds;
            }else if(payload?.searchItemSubCategoryIds === ''){
                state.vehicleConsumptionReportSearchParams.primaryFilter.searchItemSubCategoryIds = '';
            }
            if(payload?.searchItemSubCategoryNames && payload?.searchItemSubCategoryNames?.length > 0){
                state.vehicleConsumptionReportSearchParams.primaryFilter.searchItemSubCategoryNames = payload.searchItemSubCategoryNames;
            }else if(payload?.searchItemSubCategoryNames?.length === 0){
                state.vehicleConsumptionReportSearchParams.primaryFilter.searchItemSubCategoryNames = [];
            }
            if(payload?.searchBrandIds && payload?.searchBrandIds !== ''){
                state.vehicleConsumptionReportSearchParams.primaryFilter.searchBrandIds = payload.searchBrandIds;
            }else if(payload?.searchBrandIds === ''){
                state.vehicleConsumptionReportSearchParams.primaryFilter.searchBrandIds = '';
            }
            if(payload?.searchBrandNames && payload?.searchBrandNames?.length > 0){
                state.vehicleConsumptionReportSearchParams.primaryFilter.searchBrandNames = payload.searchBrandNames;
            }else if(payload?.searchBrandNames?.length === 0){
                state.vehicleConsumptionReportSearchParams.primaryFilter.searchBrandNames = [];
            }
            if(payload?.searchInvItemIds && payload?.searchInvItemIds !== ''){
                state.vehicleConsumptionReportSearchParams.primaryFilter.searchInvItemIds = payload.searchInvItemIds;
            }else if(payload?.searchInvItemIds === ''){
                state.vehicleConsumptionReportSearchParams.primaryFilter.searchInvItemIds = '';
            }
            if(payload?.searchInvItemNames && payload?.searchInvItemNames?.length > 0){
                state.vehicleConsumptionReportSearchParams.primaryFilter.searchInvItemNames = payload.searchInvItemNames;
            }else if(payload?.searchInvItemNames?.length === 0){
                state.vehicleConsumptionReportSearchParams.primaryFilter.searchInvItemNames = [];
            }
            state.vehicleConsumptionReportLists.dataLoaded = false;
        },
        vehicleConsumptionReportGetData: (state, {payload}) => {
            state.loadVehicleConsumptionReportData = payload;
        },
        vehicleConsumptionReportLoadingPending: (state) => {
            state.vehicleConsumptionReportLists.isLoading = true;
            state.vehicleConsumptionReportLists.dataLoaded = false;
            state.vehicleConsumptionReportLists.totalRecords = 0;
        },
        vehicleConsumptionReportLoadingSuccess: (state, {payload}) => {
            state.vehicleConsumptionReportLists.isLoading = false;
            state.vehicleConsumptionReportLists.data = payload;
            state.vehicleConsumptionReportLists.vehicleConsumptionReportError = '';
            state.vehicleConsumptionReportLists.dataLoaded = true;
            state.loadVehicleConsumptionReportData = false;
        },
        vehicleConsumptionReportLoadingFailed: (state, {payload}) => {
            state.vehicleConsumptionReportLists.isLoading = false;
            state.vehicleConsumptionReportLists.data = [];
            state.vehicleConsumptionReportLists.vehicleConsumptionReportError = payload;
            state.vehicleConsumptionReportLists.dataLoaded = true;
            state.loadVehicleConsumptionReportData = false;
        },
        vehicleConsumptionReportTotalRecordsUpdate: (state, {payload}) => {
            state.vehicleConsumptionReportLists.totalRecords = payload.totalRecords || 0;
        },
        vehicleConsumptionReportPageNoUpdate: (state, {payload}) => {
            state.vehicleConsumptionReportLists.pageNo = payload;
            state.loadVehicleConsumptionReportData = true;
        },
        vehicleConsumptionReportPerPageRecordsUpdate: (state, {payload}) => {
            state.vehicleConsumptionReportLists.perPageRecords = payload;
            state.vehicleConsumptionReportLists.pageNo = 0;
            state.loadVehicleConsumptionReportData = true;
        },
        vehicleConsumptionReportListReset: (state,{payload}) => {
            state.vehicleConsumptionReportLists.isLoading = false;
            state.vehicleConsumptionReportLists.dataLoaded = false;
            state.vehicleConsumptionReportLists.data = null;
            state.vehicleConsumptionReportLists.totalRecords = 0;
            state.vehicleConsumptionReportLists.pageNo = 0;
            state.vehicleConsumptionReportLists.perPageRecords = 2000;
            state.vehicleConsumptionReportLists.vehicleConsumptionReportError = '';
            state.loadVehicleConsumptionReportData = false;
        },
    }
});

const { reducer, actions } = reportVehicleConsumptionReportSlice;

export const {
    vehicleConsumptionReportPrimaryFiltersUpdates, vehicleConsumptionReportGetData,
    vehicleConsumptionReportLoadingPending,vehicleConsumptionReportLoadingSuccess,vehicleConsumptionReportLoadingFailed,
    vehicleConsumptionReportTotalRecordsUpdate, vehicleConsumptionReportPageNoUpdate, vehicleConsumptionReportPerPageRecordsUpdate,
    vehicleConsumptionReportListReset
} = actions;

export default reducer;